import React from 'react';
import intl from 'react-intl-universal';
import {observer} from 'mobx-react-lite';

import type {AppState} from '@stores/AppState';
import type {AuditTemplate} from '../../../../stores/audit/types';
import {ContextMenu} from '../../../components/ContextMenu/ContextMenu';
import {DeleteIcon} from '../../../components/icons/DeleteIcon';
import {ContextMenuInterface} from '../ContextMenuInterface';

export interface AuditRowOptionsProps extends ContextMenuInterface {
    template: AuditTemplate;
    onDeleteRequest: (template: AuditTemplate) => void;
}

export const openAuditRowOptions = (
    appState: AppState,
    template: AuditTemplate,
    mousePositionParams: any,
    onDeleteRequest: (template: AuditTemplate) => void,
) => {
    appState.setContextMenu({
        ...mousePositionParams,
        id: `audit-row-options-${template.id}`,
        type: 'audit-row-options',
        withOverlay: true,
        minWidth: 180,
        params: {template, onDeleteRequest},
    });
};

export const AuditRowOptions = observer(({handleClose, isDark, template, onDeleteRequest}: AuditRowOptionsProps) => {
    return (
        <ContextMenu
            isDark={isDark}
            handleClose={handleClose}
            items={[
                {
                    text: intl.get('common.delete').d('Delete'),
                    Icon: DeleteIcon,
                    onClick: () => {
                        onDeleteRequest(template);
                        handleClose();
                        return false;
                    },
                },
            ]}
        />
    );
});
